import { WithSkeleton } from '@capsicum/common';
import { memo } from 'react';

import { NCWSendAssetCardComponent } from './NCWSendAssetCardComponent';
import { NCWSendAssetCardSkeleton } from './NCWSendAssetCardSkeleton';

/**
 * The asset card component (including skeleton) used by NCWSendAssetSelector
 */
export const NCWSendAssetCard = memo(WithSkeleton(NCWSendAssetCardComponent, NCWSendAssetCardSkeleton));
